// Mapping des anciennes valeurs espagnoles (stockées en BDD avant i18n) vers les clés de traduction

const legacyToKeyMap = {
  // Offensive roles
  'Generador con balón': 'ballHandler',
  'Generador secundario con balón': 'secondaryBallHandler',
  'Anotador Dominante': 'dominantScorer',
  'Base Director': 'floorGeneral',
  'Tirador Especialista': 'shootingSpecialist',
  'Alero Generador': 'creatorWing',
  'Ala Versátil': 'versatileWing',
  'Alero Fuerte': 'strongWing',
  'Alero Slasher': 'slasherWing',
  'Alero Spot-up': 'spotUpWing',
  '3&D': 'threeAndD',
  'Ala-Pívot Tradicional': 'traditionalPowerForward',
  'Skilled Forward': 'skilledForward',
  '4 Abierto': 'stretchFour',
  'Pívot Generador': 'creatorCenter',
  'Pívot Versátil': 'versatileCenter',
  'Pívot Mid-Range': 'midRangeCenter',
  '5 Abierto': 'stretchFive',
  'Anotador en el poste bajo': 'postScorer',
  'Pívot finalizador cerca del aro': 'rimFinisher',
  'Pívot de bloqueo y continuación': 'pickAndRollBig',
  'Rol Ofensivo Marginal': 'marginalOffensiveRole',
  // Defensive roles
  '1x1 Intenso': 'intenseOneOnOne',
  'Defensor Perimetral': 'perimeterDefender',
  'Wing Stopper': 'wingStopper',
  'Switch Defensor': 'switchDefender',
  'Anchor Big': 'anchorBig',
  'Reboteador Defensivo': 'defensiveRebounder',
  'Rim Protector': 'rimProtector',
  'Point of Attack': 'pointOfAttack',
  'Lento lateralmente': 'slowLaterally',
  'Elefante': 'slowLaterally',
  'No Defensor': 'nonDefender',
  // JE Attributes
  '1x1': 'oneOnOne',
  '3-Level Scorer': 'threeLevelScorer',
  'Actividad sin balón': 'offBallActivity',
  'Atlético': 'athletic',
  'Capacidad en el Pick & Roll': 'pickAndRollAbility',
  'Capacidad para sacar faltas': 'foulDrawing',
  'Clutch': 'clutch',
  'Duro': 'tough',
  'Energía': 'energy',
  'Envergadura': 'wingspan',
  'Físico': 'physical',
  'Hustle': 'hustle',
  'IQ/Visión de juego': 'bbiq',
  'Juego en el poste bajo': 'postGame',
  'Paint Touches': 'paintTouches',
  'Slasher': 'slasher',
  'Scoring': 'scoring',
  'Primer paso': 'firstStep',
  'Producción consistente': 'consistentProduction',
  'Rebote': 'rebounding',
  'Talento': 'talent',
  'Tirador': 'shooter',
  'Catch & Shoot': 'catchAndShoot',
  'Esquina/3pts': 'cornerThree',
  'Pull-up Shooting': 'pullUpShooting',
  'Transición': 'transition',
  'Blue Collar': 'blueCollar',
  'Velocidad/Agilidad': 'speedAgility',
  'Versatilidad': 'versatility',
  'Verticalidad': 'verticality',
  // JI Attributes
  'Bloqueo, continuación y finalización': 'screenAndRoll',
  'Bloqueos eficaces': 'effectiveScreens',
  'Buen tacto': 'softTouch',
  'Footwork': 'footwork',
  'Juego poste bajo/Juego de cara': 'postUpFaceUp',
  'Lob Threat': 'lobThreat',
  'Protección del aro': 'rimProtection',
  'Rim Runner': 'rimRunner',
  'Esquina/Pop-out': 'cornerThreePopOut',
  'Esfuerzo múltiple': 'multipleEfforts',
};

// Normalise une valeur CSV (anciennes valeurs espagnoles ou clés) vers les clés de traduction
export const normalizeRoleValue = (csvValue) => {
  if (!csvValue) return '';
  return csvValue
    .split(',')
    .map(v => v.trim())
    .filter(Boolean)
    .map(v => legacyToKeyMap[v] || v)
    .join(',');
};

// Normalise un seul élément
export const normalizeSingleValue = (value) => {
  if (!value) return value;
  return legacyToKeyMap[value] || value;
};

// Normalise un array de valeurs
export const normalizeArrayValues = (arr) => {
  if (!Array.isArray(arr)) return arr;
  return arr.map(v => legacyToKeyMap[v] || v);
};

export { legacyToKeyMap };
export default legacyToKeyMap;
